import React, { useEffect } from "react";
import { Col, Row, Card, CardBody, Button, Table, Container } from 'reactstrap';
import { reduxForm } from 'redux-form';
import ThirdsApi from '../api/thirds_api';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import Spinner from 'react-bootstrap/Spinner';
import IndicatorsApi from '../api/indicators_api';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import AppointmentOpportunityRes0256ToExcel from "../exports/excel/AppointmentOpportunityRes0256ToExcel";
import TenCorrectsExcel from "../exports/excel/TenCorrectsExcel";
import FallingRiskMorseScale from '../exports/excel/FallingRiskMorseScale';
import AssignementUserAppointmentExcel from '../exports/excel/AssignementUserAppointmentExcel';
import AppointmentOpportunityToExcel from "../exports/excel/AppointmentOpportunityToExcel";

const Indicators = ({ history, location }) => {
    //Filters
    const [starterDate, setStarterDate] = React.useState(null);
    const [finalDate, setFinalDate] = React.useState(null);
    const [thirds, setThirds] = React.useState([]);
    const [thirdSelected, setThirdSelected] = React.useState(0);

    //Results
    const [indicators, setIndicators] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        handleChangeFilters(true);
        findThirdsForIndicators();
    }, []);

    const findThirdsForIndicators = async () => {
        let thirdsList = await ThirdsApi.listThirdsIndicators();
        setThirds(thirdsList);
    }

    const handleChangeThird = async (value) => {
        await setThirdSelected(value);
        await handleChangeFilters(false);
    }

    const handleChangeStarterDate = async (value) => {
        await setStarterDate(value);
        await handleChangeFilters(false);
    }

    const handleChangeFinalDate = async (value) => {
        await setFinalDate(value);
        await handleChangeFilters(false);
    }

    const handleChangeFilters = async (starter) => {
        try {
            setIsLoading(true);
            let indicadores = [
                {
                    tipo: 1,
                    nombre: "Oportunidad de Cita Resolucion 0256",
                },
                {
                    tipo: 2,
                    nombre: "Indicador de los 10 Correctos",
                },
                {
                    tipo: 3,
                    nombre: "Riesgo de Caida Escala Morse",
                },
                {
                    tipo: 4,
                    nombre: "Asignación de Citas por Usuario"
                },
                {
                    tipo: 5,
                    nombre: "Oportunidad de Cita"
                },
            ]
            setIndicators(indicadores);
            setIsLoading(false);
        }
        catch (err) {
            console.log(err);
        }
    }

    const exportExcel = async (opt) => {
        setIsLoading(true);
        let filtroIndicador = null;
        switch (opt) {
            case 1://------- Indicador de Oportunidad de Cita Resolución 0256 -------//
                if (starterDate == null) {
                    alert("Debe seleccionar la Fecha Inicial");
                    break;
                }
                if (finalDate == null) {
                    alert("Debe seleccionar la Fecha Final");
                    break;
                }
                let indicadorOpCitaRes0256 = [];
                if (thirdSelected != 0 && starterDate != null && finalDate != null) { //Con tercero seleccionado
                    filtroIndicador = {
                        "fecha_inicio": moment(`${moment(starterDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        "fecha_final": moment(`${moment(finalDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                        "id_tercero": thirdSelected
                    }
                    indicadorOpCitaRes0256 = await IndicatorsApi.appointmentOpportunityRes0256(filtroIndicador);
                    if (indicadorOpCitaRes0256.indicador != null) {
                        await AppointmentOpportunityRes0256ToExcel.exportExcel(indicadorOpCitaRes0256.indicador);
                    }
                    else {
                        alert("No se encontraron datos para generar este excel");
                    }
                }
                else if (starterDate != null && finalDate != null) {//Sin tercero Seleccionado
                    filtroIndicador = {
                        "fecha_inicio": moment(`${moment(starterDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        "fecha_final": moment(`${moment(finalDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                        "id_tercero": null
                    }
                    indicadorOpCitaRes0256 = await IndicatorsApi.appointmentOpportunityRes0256(filtroIndicador);
                    {
                        if (indicadorOpCitaRes0256.indicador != null) {
                            await AppointmentOpportunityRes0256ToExcel.exportExcel(indicadorOpCitaRes0256.indicador);
                        }
                        else {
                            alert("No se encontraron datos para generar este excel");
                        }
                    }
                }
                break;
            case 2:
                if (starterDate != null && finalDate != null) {
                    filtroIndicador = {
                        "fecha_inicio": moment(`${moment(starterDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        "fecha_final": moment(`${moment(finalDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                        "id_tercero": null
                    }
                    let indicador10Correctos = await IndicatorsApi.tenCorrectsIndicator(filtroIndicador);
                    if (indicador10Correctos.indicador != null && indicador10Correctos.indicador != undefined) {
                        TenCorrectsExcel.exportExcel(indicador10Correctos.indicador);
                    }
                    else {
                        alert("Ha ocurrido un error en el servidor");
                    }
                }
                else {
                    alert("La Fecha de Inicio y Fecha Final es Obligatoria");
                }
                break;
            case 3:
                try {
                    if (starterDate != null && finalDate != null) {
                        filtroIndicador = {
                            "fecha_inicio": moment(`${moment(starterDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                            "fecha_final": moment(`${moment(finalDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                            "id_tercero": null
                        }

                        let indicatorFallingRisk = await IndicatorsApi.listFallingRisk(filtroIndicador);
                        FallingRiskMorseScale.exportExcel(indicatorFallingRisk.reporte);
                    }
                    else {
                        alert("La Fecha de Inicio y Fecha Final es Obligatoria");
                    }
                }
                catch (e) {
                    console.log(e);
                }
                break;
            case 4:
                try {
                    if (starterDate != null && finalDate != null) {
                        filtroIndicador = {
                            "fecha_inicio": moment(`${moment(starterDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                            "fecha_final": moment(`${moment(finalDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                            "id_tercero": thirdSelected != 0 && thirdSelected != null && thirdSelected != undefined ? thirdSelected : null
                        }
                        let indicatorAssignementAppointmentUser = await IndicatorsApi.asignementAppointmentsFromUser(filtroIndicador);

                        console.log("indicatorAssignementAppointmentUser", indicatorAssignementAppointmentUser);

                        AssignementUserAppointmentExcel.exportExcel(indicatorAssignementAppointmentUser.indicador, starterDate, finalDate, indicatorAssignementAppointmentUser.cantidad);
                    }
                    else {
                        alert("La Fecha de Inicio y Fecha Final es Obligatoria");
                    }
                }
                catch (e) {
                    console.log(e);
                }
                break;
            case 5://------- Indicador de Oportunidad de Cita -------//
                if (starterDate == null) {
                    alert("Debe seleccionar la Fecha Inicial");
                    break;
                }
                if (finalDate == null) {
                    alert("Debe seleccionar la Fecha Final");
                    break;
                }
                let indicadorOpCitaRes = [];
                if (thirdSelected != 0 && starterDate != null && finalDate != null) { //Con tercero seleccionado
                    filtroIndicador = {
                        "fecha_inicio": moment(`${moment(starterDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        "fecha_final": moment(`${moment(finalDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                        "id_tercero": thirdSelected
                    }
                    indicadorOpCitaRes = await IndicatorsApi.appointmentOpportunity(filtroIndicador);
                    if (indicadorOpCitaRes.indicador != null) {
                        await AppointmentOpportunityToExcel.exportExcel(indicadorOpCitaRes.indicador);
                    }
                    else {
                        alert("No se encontraron datos para generar este excel");
                    }
                }
                else if (starterDate != null && finalDate != null) {//Sin tercero Seleccionado
                    filtroIndicador = {
                        "fecha_inicio": moment(`${moment(starterDate).format('YYYY/MM/DD')} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
                        "fecha_final": moment(`${moment(finalDate).format('YYYY/MM/DD')} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
                        "id_tercero": null
                    }
                    indicadorOpCitaRes = await IndicatorsApi.appointmentOpportunity(filtroIndicador);
                    {
                        if (indicadorOpCitaRes.indicador != null) {
                            await AppointmentOpportunityToExcel.exportExcel(indicadorOpCitaRes.indicador);
                        }
                        else {
                            alert("No se encontraron datos para generar este excel");
                        }
                    }
                }
                break;
            default:
                break;
        }
        setIsLoading(false);
        return;
    }

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col md={12}>
                        <div className="card__title">
                            <h5 className="bold-text">Filtros</h5>
                        </div>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={4}>
                        <TextField
                            id="select_third"
                            select
                            label="Tercero"
                            value={thirdSelected}
                            className='medical-material-form__field'
                            onChange={(event) => {
                                handleChangeThird(event.target.value);

                            }}

                            style={{ minWidth: '300px', maxWidth: '100%' }}
                        >
                            <MenuItem selected={true} key={0} value={0}>
                                Sin Tercero                                </MenuItem>
                            {thirds.map((third) => {
                                return <MenuItem key={third.id_tercero} value={third.id_tercero}>
                                    {third.nombre}
                                </MenuItem>
                            })}
                        </TextField>
                        <br /><br />
                    </Col>
                    <Col md={4}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <KeyboardDatePicker
                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                value={starterDate}
                                onChange={(date) => {
                                    handleChangeStarterDate(date);
                                }}
                                label="Fecha Inicial"
                                format="DD/MM/YYYY"
                                animateYearScrolling
                                className='medical-material-form__field material-form__label'
                                autoOk={true}
                                disableFuture
                            />
                        </MuiPickersUtilsProvider>
                        <br /><br />
                    </Col>
                    <Col md={4}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <KeyboardDatePicker
                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                value={finalDate}
                                onChange={(date) => {
                                    handleChangeFinalDate(date);
                                }}
                                label="Fecha Final"
                                format="DD/MM/YYYY"
                                animateYearScrolling
                                className='medical-material-form__field material-form__label'
                                autoOk={true}
                                disableFuture
                            />
                        </MuiPickersUtilsProvider>
                        <br /><br />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={12}>
                        {isLoading && <Spinner animation="border" variant="success" />}
                        {indicators.length > 0 && (
                            <Container>
                                <Row className="container-list-reports">
                                    {indicators.map(elem => (
                                        <Col sm={12} md={4} className='element-report'>
                                            <div>
                                                <FontAwesomeIcon className="text-success" style={{ fontSize: '20px' }} icon={faFileExcel} />
                                                <a href="#" onClick={() => exportExcel(elem.tipo, elem.datos)}>
                                                    {elem.nombre}
                                                </a>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Container>
                        )}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
}

export default reduxForm({
    form: 'horizontal_form_indicators',
})(Indicators);